// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3_InV","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1A21Q"};